<div class="map-container container"  [ngClass]="{ready: isReady}" fxFlexFill>
  <div class="map" #mapContainer [ngClass]="{opacityLow:isLoadingPopulation}"></div>

  <mtn-filter-toolbar [map]="map" *ngIf="map?.options.controlConfiguration.isFiltersEnabled"></mtn-filter-toolbar>

  <div class="map-controls-container" fxLayout="column" *ngIf="map"
       [ngClass]="{'street-view-active': map.getStreetView()?.getVisible(),
       'filters-enabled': map.options.controlConfiguration.isFiltersEnabled}">
    <mtn-map-controls-toolbar (buttonClicked)="storeButtonClicked($event)" [map]="map"></mtn-map-controls-toolbar>
  </div>

  <div class="selection-advice-container" *ngIf="showSelectionAdvice" fxLayout="row">
    <div class="advice-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <fa-icon class="color-help" icon="info-circle"></fa-icon>
      <div [ngSwitch]="map.selectionMode">
        <div *ngSwitchCase="MapSelectionMode.MULTI_SELECT">{{"CLICK_ON_MARKER" | translate}}
        </div>
        <div *ngSwitchCase="MapSelectionMode.LASSO">{{'DRAW_MARKER' | translate}}
        </div>
        <div *ngSwitchCase="MapSelectionMode.RING">{{'ENTER_RADIUS' | translate}}
        </div>
      </div>
    </div>
  </div>

  <div class="loading-indicator-container" [ngClass]="{'fade-out': !isLoadingFeatures}" fxLayoutAlign="center center">
    <img src="../../assets/images/cube-preloader.svg" height="90px" width="90px;" alt="Loading Indicator"/>
  </div>
  <!-- <div *ngIf="showDropPin" class="drop-pin " [ngClass]="addDropPin ? 'highlightClass' : '' " (click)="toggleDropPin()"  fxLayoutAlign="center center">
    <img height="20" width="20" src="/assets/images/location-svg.svg"/>
    {{'DROP_PIN_TO_PROJECT_GROCERY_SALES' | translate }}
  </div> -->
</div>
<mtn-spinner [size]="SpinnerSize.EXTRA_LARGE" [on]="isLoadingPopulation"></mtn-spinner>
